// extracted by mini-css-extract-plugin
export default {"form":"UpdateUser_form__6pAxd","articleTitle":"UpdateUser_articleTitle__-dUxi","btn":"UpdateUser_btn__VXZF+"};